import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

import { NIKE_URL } from "@/data/constants/url";
import { useAuth } from "@/features/auth/shared/hooks/use-auth";
import { useLang } from "@/hooks/use-lang";
import { Lang } from "@/i18n-config";

export const responseSchema = z.object({
  data: z.array(
    z
      .object({
        investorId: z.string(),
        investor: z.string(),
        investorName: z.string(),
        investorNameEn: z.string(),
        representative: z.string().nullable(),
        investorDescription: z.string(),
        updatedAt: z.string(),
      })
      .partial()
  ),
  message: z.string(),
});

export type Form13FInvestor = z.infer<typeof responseSchema>["data"][0];

type Params = {
  lang?: Lang;
  token?: string;
};

export const get13FInvestorList = async (
  params?: Params
): Promise<Form13FInvestor[]> => {
  const endpoint = "/default/search/13f";
  const headers = new Headers({ "Accept-Language": params?.lang ?? "zh" });
  if (params?.token) {
    headers.append("X-User-Profile", params.token);
  }

  const res = await fetch(`${NIKE_URL}${endpoint}`, {
    method: "GET",
    headers,
  });

  if (!res.ok) throw new Error(`API failed (${endpoint})`);
  return responseSchema.parse(await res.json()).data;
};

export const use13FDefaultSearch = () => {
  const { lang } = useLang();
  const { backendToken } = useAuth();

  return useQuery(["13f-default-search", lang, backendToken], () =>
    get13FInvestorList({ lang, token: backendToken })
  );
};
